import * as React from "react";
import { useParams } from "react-router-dom";
import DrinkProductPage from "./drink_product_page";
function ProductPage() {
  const { id } = useParams();
  return <DrinkProductPage type={id} />;
}

export default ProductPage;
